import { useState } from "react";

// Default error fallback component
export default function DefaultErrorFallback({
  error,
  errorInfo,
  errorId,
}: {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
  errorId: string;
}) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div
      style={{
        padding: "20px",
        margin: "20px",
        border: "2px solid #ff6b6b",
        borderRadius: "8px",
        backgroundColor: "#fff5f5",
        fontFamily: "monospace",
      }}
    >
      <h2 style={{ color: "#d63031", margin: "0 0 10px 0" }}>
        🚨 Something went wrong
      </h2>

      <p style={{ margin: "10px 0", color: "#2d3436" }}>
        An error occurred in the application. Error ID:{" "}
        <strong>{errorId}</strong>
      </p>

      {error && (
        <div style={{ margin: "10px 0" }}>
          <p>
            <strong>Error:</strong> {error.name}: {error.message}
          </p>
        </div>
      )}

      <button
        onClick={() => setShowDetails(!showDetails)}
        style={{
          background: "#74b9ff",
          color: "white",
          border: "none",
          padding: "8px 16px",
          borderRadius: "4px",
          cursor: "pointer",
          margin: "10px 0",
        }}
      >
        {showDetails ? "Hide Details" : "Show Details"}
      </button>

      {showDetails && (
        <div
          style={{
            marginTop: "15px",
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            fontSize: "12px",
            maxHeight: "300px",
            overflow: "auto",
          }}
        >
          {error && (
            <div>
              <h4>Error Stack:</h4>
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {error.stack}
              </pre>
            </div>
          )}

          {errorInfo && (
            <div>
              <h4>Component Stack:</h4>
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {errorInfo.componentStack}
              </pre>
            </div>
          )}
        </div>
      )}

      <div style={{ marginTop: "15px", fontSize: "12px", color: "#636e72" }}>
        <p>
          Please report this error with ID: <code>{errorId}</code>
        </p>
        <p>Timestamp: {new Date().toISOString()}</p>
      </div>
    </div>
  );
}
